// 2021.02.08.ADivelbiss - Added to support page pre-requisites checking.
// Needed to handle routing to a specific page.  If the required data has not
// been provided in the session then we must not show the page.
// Defines pre-conditions for displaying a given page.
// that is, these are PRE-CONDITIONS for showing a page


import Resources from "../Resources/Resources";
import {BENEFICIARY_TRUST, FINANCES_NET_WORTH_MIN, FUNDS, GENERAL, MAX_AGE, MIN_AGE} from "./constants";
import {NassauLog} from "./myga-utils";
import {MM_PAYMENT, MM_PRODUCT_FAMILY, MM_PRODUCT_ID} from "./myga-model";

const {getAgeFromDOB,FINANCES_INCOME_ANNUAL_MIN, AGENT_INFO, STORAGE_KEYS, APP_SUBMISSION, BENEFICIARY,
  BENEFICIARY_SURVIVOR_UID
} = require("./constants");
const {QUESTION_VISUAL_ORIENTATION} = require("./myga-model");
const {QUESTION_RESPONSE_VALUE, MM_PRODUCT_DTO} = require("./myga-model");
const {
  PAGES,
  APP_SECTION,
  GOALS,
  NEEDS,
  FINANCES,
  ID_VERIFY,
  ID_DATA_ENTRY,
  PARTY,
  PARTY_RELATIONSHIPS,
  ENTITY_TYPE,
  OWNER_TYPE,
  ANNUITANT_TYPE,
  BENEFICIARY_TYPE,
} = require("./constants");
const {
  QUESTION_INPUT_TYPE,
  QUESTION_CATEGORY,
  QUESTION_SUBCATEGORY,
  QUESTION_RESPONSE_TYPE,
  QUESTION_VISUAL_PRIORITY,
  QUESTION_VISUAL_PRESENCE
} = require("./myga-model");
const moment = require("moment");


const _CONDITION_NAMES = {
  isReferralCodeValid: 'isReferralCodeValid',
  knockout: 'knockout',
  knockoutFinances: 'knockoutFinances',
  knockoutAny: 'knockoutAny',
  isFL: 'isFL',
  isFLNonRecommendation: 'isFLNonRecommendation',
  hasPremium4Year: 'hasPremium4Year',
  hasPremium5Year: 'hasPremium5Year',
  hasPremium6Year: 'hasPremium6Year',
  hasPremium7Year: 'hasPremium7Year',
  isProductCartItemValid: 'isProductCartItemValid',
  isProductCartValid: 'isProductCartValid',
  isRecommendation: 'isRecommendation',
  isCD: 'isCD',
  isIRA: 'isIRA',
  isUsingQualifiedFunds: 'isUsingQualifiedFunds',
  GOAL_isReplacement: 'GOAL_isReplacement',
  isReplacementFL: 'isReplacementFL',
  willStopPayments: 'willStopPayments',
  isReplacement: 'isReplacement',
  isReplacementOrCD: 'isReplacementOrCD',
  didConsent: 'didConsent',
  isBeneSurvivor: 'isBeneSurvivor',
  isPathA: 'isPathA',
  isPathB: 'isPathB',
  isPathC: 'isPathC',
  isSourceOfFundsOK: 'isSourceOfFundsOK',
  isSourceOfIncomeOK: 'isSourceOfIncomeOK',
  isSourceOfFundsNonQualOrIRAOK: 'isSourceOfFundsNonQualOrIRAOK',
  areFinancialObjectivesOK: 'areFinancialObjectivesOK',
  isRiskToleranceOK: 'isRiskToleranceOK',
  isFedIncomeTaxBracketOK: 'isFedIncomeTaxBracketOK', // 2022.04.06.ADivelbiss - no longer needed
  isPartyOK: 'isPartyOK',
  isEachPartyOK: 'isEachPartyOK',
  isPartyRelationshipOK: 'isPartyRelationshipOK',
  isEachPartyRelationshipOK: 'isEachPartyRelationshipOK',
  isPartyScenarioValid: 'isPartyScenarioValid',
  isPartyTheOwner: 'isPartyTheOwner', // the owner
  isPartyTheAnnuitant: 'isPartyTheAnnuitant', // the annuitant
  isPartyTheJointOwner: 'isPartyTheJointOwner', // the joint owner
  isPartyTheJointAnnuitant: 'isPartyTheJointAnnuitant', // the joint annuitant
  isPartyAnOwner: 'isPartyAnOwner', // either owner or joint owner
  isPartyAnAnnuitant: 'isPartyAnAnnuitant', // either annuitant or joint annuitant
  isPartyATrust: 'isPartyATrust',
  isPartyAnIndividual: 'isPartyAnIndividual', // Used in hasOwnerAsIndividual
  isPartyASpouse: 'isPartyASpouse',
  isPartyInFlorida: 'isPartyInFlorida',
  isPartyAgeGTE72: 'isPartyAgeGTE72',
  hasOwner: 'hasOwner',
  hasOwnerAsTrust: 'hasOwnerAsTrust',
  hasOwnerAsIndividual: 'hasOwnerAsIndividual', // Owner is not a trust
  hasOwnerSameAsAnnuitant: 'hasOwnerSameAsAnnuitant',
  hasOwnerInFlorida: 'hasOwnerInFlorida',
  hasValidOwner: 'hasValidOwner',
  hasAnnuitant: 'hasAnnuitant',
  hasJointOwner: 'hasJointOwner',
  hasJointAnnuitant: 'hasJointAnnuitant',
  hasJointOwnerAsSpouse: 'hasJointOwnerAsSpouse',
  hasSurvivingSpouseForPrimaryBene: 'hasSurvivingSpouseForPrimaryBene',
  needsSurvivingSpouseForPrimaryBene: 'needsSurvivingSpouseForPrimaryBene',
  canAddOwner: 'canAddOwner',
  canAddAnnuitant: 'canAddAnnuitant',
  canAddJointOwner: 'canAddJointOwner',
  canAddJointAnnuitant: 'canAddJointAnnuitant',
  canAddParty: 'canAddParty',
  canEditPartyRoles: 'canEditPartyRoles',
  hasPayments: 'hasPayments',
  isPaymentScenarioValid: 'isPaymentScenarioValid',
  showMailInfo: 'showMailInfo',
  showConfirmEFT: 'showConfirmEFT',
  hasMinimumAllocations: 'hasMinimumAllocations',
  hasPrimaryBenes: 'hasPrimaryBenes',
  isPrimaryAllocationComplete: 'isPrimaryAllocationComplete',
  hasContingentBenes: 'hasContingentBenes',
  isContingentAllocationComplete: 'isContingentAllocationComplete',
  isTrustValid: 'isTrustValid',
  areAllTrustsValid: 'areAllTrustsValid',
  isIndividualBeneValid: 'isIndividualBeneValid',
  areAllIndividualsBeneValid: 'areAllIndividualsBeneValid',
  hasValidNumberOfBenes: 'hasValidNumberOfBenes',
  isBeneValid: 'isBeneValid',
  isBenesValid: 'isBenesValid',
  hasValidNetWorth: 'hasValidNetWorth',
  canShowAppFinalizePage: 'canShowAppFinalizePage',
  isMYAnnuity: 'isMYAnnuity',
  isNoFreeWithdrawal: 'isNoFreeWithdrawal',
  isAnyOwnerAgeGTE72: 'isAnyOwnerAgeGTE72',
  isIRARollover: 'isIRARollover',
  isRMD: 'isRMD'
};
export const CONDITION_NAMES = _CONDITION_NAMES;

// An array of named conditions that can be used
// in the page prerequisites object or elsewhere to
// validate collected data
const _CONDITIONS = Object.freeze([
  { // if true, a general knockout condition applies
    name: _CONDITION_NAMES.knockout,
    condition: {
      OR: [
        {
          section: APP_SECTION.identity1,
          question: ID_VERIFY.citizenship,
          operator: '!=',
          value: 'Yes'
        },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerApplicantImpaired,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerUsingReverseMortgage,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.funds,
          question: FUNDS.expectLumpSumPayments,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.general,
          question: GENERAL.assistedLiving,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.general,
          question: GENERAL.terminalIllness,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.general,
          question: GENERAL.memoryDisease,
          operator: '==',
          value: 'Yes'
        }
      ]
    }
  },
  { // if true, a finances related knockout condition applies
    name: _CONDITION_NAMES.knockoutFinances,
    condition: {
      AND: [
        { // finances questions are complete
          name: PAGES.pageAppFinances,
          value: true
        },
        { // AND none of the finance knockout questions apply
          OR: [
            {
              section: APP_SECTION.finances,
              question: FINANCES.incomeAnnual,
              operator: '<',
              value: FINANCES_INCOME_ANNUAL_MIN
            },
            {
              operandLeft: {
                section: APP_SECTION.finances,
                key: FINANCES.expensesAnnual,
              },
              operator: '>',
              operandRight: {
                section: APP_SECTION.finances,
                key: FINANCES.incomeAnnual
              }
            },
            {
              operandLeft: {
                section: APP_SECTION.finances,
                key: FINANCES.liquidAssets,
              },
              operator: '<',
              operandRight: {
                section: APP_SECTION.finances,
                key: FINANCES.expensesAnnual,
                scale: (3.0/12.0)
              },
            },
            {
              AND: [
                {
                  operandLeft: {
                    section: APP_SECTION.finances,
                    key: FINANCES.ageGTE65,
                  },
                  operator: '==',
                  value: 'Yes'
                },
                {
                  operandLeft: {
                    section: APP_SECTION.finances,
                    key: FINANCES.liquidAssets,
                  },
                  operator: '<',
                  operandRight: {
                    section: APP_SECTION.finances,
                    key: FINANCES.expensesAnnual,
                    scale: (6.0 / 12.0)
                  },
                },
              ]
            }
          ]
        }
      ]
    }
  },
  { // if true, any knockout condition applies
    name: _CONDITION_NAMES.knockoutAny,
    condition: {
      OR: [
        {
          name:_CONDITION_NAMES.knockout,
          value: true
        },
        {
          name:_CONDITION_NAMES.knockoutFinances,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.hasPremium4Year,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.surrenderPeriod,
          },
          operator: '==',
          value: 4
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasPremium5Year,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.surrenderPeriod,
          },
          operator: '==',
          value: 5
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasPremium6Year,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.surrenderPeriod,
          },
          operator: '==',
          value: 6
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasPremium7Year,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.surrenderPeriod,
          },
          operator: '==',
          value: 7
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.isProductCartItemValid,
    condition:{
      operandLeft: {
        key: MM_PRODUCT_DTO.premium
      },
      operator: 'isValid',
      value: true
    }
  },
  {
    name: _CONDITION_NAMES.isProductCartValid,
    condition: { // each party must be valid to return true
      AND:[
        {
          FOR_ALL: { // apply same condition to all objects in array
            section: APP_SECTION.products,
            condition: {
              name: _CONDITION_NAMES.isProductCartItemValid,
              value: true
            }
          }
        },
        {
          FOR_ANY: { // apply same condition to all objects in array
            section: APP_SECTION.products,
            condition: {
              name: _CONDITION_NAMES.isProductCartItemValid,
              value: true
            }
          }
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isRecommendation,
    condition: {
      section: STORAGE_KEYS.AgentInfo,
      question: AGENT_INFO.recommendationCode,
      operator: '>=',
      value: 0
    }
  },
  {
    name: _CONDITION_NAMES.isCD,
    condition: {
      section: APP_SECTION.finances,
      question: FINANCES.sourceOfFundsCD,
      operator: '==',
      value: 'Yes'
    }
  },
  {
    name: _CONDITION_NAMES.isIRA,
    condition: {
      OR: [
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFunds401K,
          operator: '==',
          value: 'Yes'
        },
        {
          name: _CONDITION_NAMES.isIRARollover,
          value: true
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isUsingQualifiedFunds,
    condition: {
      OR: [
        // {
        //   section: APP_SECTION.finances,
        //   function: (finances) => {
        //     // inject a test funciton
        //     NassauLog(`finances: ${JSON.stringify(finances,null,2)}`);
        //     return false;
        //   }
        // },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerUsingQualifiedFunds,
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsStocks,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsVA,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsIA,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFunds401K,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsLI,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsPP,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsMM,
          },
          operator: '==',
          value: 'Yes'
        },
        {
          operandLeft: {
            section: APP_SECTION.finances,
            key:FINANCES.sourceOfFundsTSP,
          },
          operator: '==',
          value: 'Yes'
        },
      ]
    }
  },
  { // Checks the is replacement question on the goals page
    name: _CONDITION_NAMES.GOAL_isReplacement,
    condition: {
      section: APP_SECTION.goals,
      question: GOALS.answerIsReplacement,
      operator: '==',
      value: 'Yes'
    }
  },
  { // Checks the is replacement question on the goals page
    name: _CONDITION_NAMES.isReplacementFL,
    condition: {
      section: APP_SECTION.funds,
      question: FUNDS.replacement,
      operator: '==',
      value: 'Yes'
    }
  },
  {
    name: _CONDITION_NAMES.willStopPayments,
    condition: {
      section: APP_SECTION.goals,
      question: GOALS.answerStopPaymentOnOtherPolicies,
      operator: '==',
      value: 'Yes'
    }
  },
  {
    name: _CONDITION_NAMES.isReplacement,
    condition: {
      OR: [
        {
          name: _CONDITION_NAMES.isUsingQualifiedFunds,
          value: true
        },
        {
          name: _CONDITION_NAMES.GOAL_isReplacement,
          value: true
        },
        {
          name: _CONDITION_NAMES.isReplacementFL,
          value: true
        },
        {
          name: _CONDITION_NAMES.willStopPayments,
          value: true
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsFA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsVA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsIA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsLI,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsDP,
          operator: '==',
          value: 'Yes'
        }
      ]
    }
  },
  {// if this condition is true then payment page is skipped
    name: _CONDITION_NAMES.isReplacementOrCD,
    condition: {
      OR: [
        {
          name: _CONDITION_NAMES.isReplacement,
          value: true
        },
        {
          name: _CONDITION_NAMES.isCD,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isSourceOfFundsOK,
    condition: {
      OR: [
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsStocks,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsCD,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsFA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsVA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsIA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFunds401K,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsPSP,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsCS,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsLI,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsPP,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsDP,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsMM,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfFundsTSP,
          operator: '==',
          value: 'Yes'
        }
      ]
    }
  },
  { // returns true if all required finance have been answered
    name: PAGES.pageAppFinances,
    condition: {
      AND: [
        {
          section: APP_SECTION.finances,
          question: FINANCES.otherContracts,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.incomeAnnual,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.expensesAnnual,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.netWorth,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.liquidAssets,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.ageGTE65,
          operator: '!=',
          value: ''
        }
      ]
    },
  },
  {
    name: _CONDITION_NAMES.isSourceOfIncomeOK,
    condition: {
      OR: [
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeWages,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomePension,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeSS,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeInvestment,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeRMD,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncome72TQ,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeDisability,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.sourceOfIncomeOther,
          operator: '==',
          value: 'Yes'
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isSourceOfFundsNonQualOrIRAOK,
    condition: {
      OR: [
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFunds1035,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsNewPurchase,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsTradIRA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsRothIRA,
          operator: '==',
          value: 'Yes'
        },
        {
          AND: [
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSepIRA,
              operator: '==',
              value: 'Yes'
            },
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSepIRAName,
              operator: '!=',
              value: ''
            },
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSepIRATaxID,
              operator: '!=',
              value: ''
            }
          ]
        },
        {
          AND: [
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSimpleIRA,
              operator: '==',
              value: 'Yes'
            },
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSimpleIRAName,
              operator: '!=',
              value: ''
            },
            {
              section: APP_SECTION.finances,
              key: FINANCES.sourceOfFundsSimpleIRATaxID,
              operator: '!=',
              value: ''
            }
          ]
        },
      ]
    }
  },
  { // returns true if all required finance have been answered
    name: PAGES.pageAppFinancesFL,
    condition: {
      AND: [
        {
          section: APP_SECTION.finances,
          question: FINANCES.incomeAnnual,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.expensesAnnual,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.netWorth,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.liquidAssets,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.ageGTE65,
          operator: '!=',
          value: ''
        },
        {
          name: _CONDITION_NAMES.isSourceOfIncomeOK,
          value: true
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.annuityOwnership,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.lifeOwnership,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.incomeCoversExpenses,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.livingExpensesChange,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.medicalExpensesChange,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.finances,
          question: FINANCES.hasEmergencyFund,
          operator: '!=',
          value: ''
        },
       // TODO: Add the FL Finance question conditions here.
       ]
    },
  },
  { // returns true if all required suitability goals questions have been answered
    name: PAGES.pageAppGoals,
    condition: {
      AND: [
        {
          section: APP_SECTION.goals,
          question: GOALS.answerNeedEarlyAccessToMoney,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerIsReplacement,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerStopPaymentOnOtherPolicies,
          operator: '!=',
          value: ''
        },
        {
          name: _CONDITION_NAMES.isSourceOfFundsOK,
          value: true
        },
        {
          name: _CONDITION_NAMES.isSourceOfFundsNonQualOrIRAOK,
          value: true
        },
        {
          section: APP_SECTION.goals,
          question: GOALS.answerSourceOfFundsPenalty,
          operator: '!=',
          value: ''
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.areFinancialObjectivesOK,
    condition: {
      OR: [ // 2022.04.27.ADivelbiss - in FL either objectivePotentialGrowth or objectiveSafetyAndGrowth is required
        {
          section: APP_SECTION.needs,
          question: NEEDS.objectivePotentialGrowth,
          operator: '==',
          value: 'Yes'
        },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectivePreservation,
        //   operator: '==',
        //   value: 'Yes'
        // },
        {
          section: APP_SECTION.needs,
          question: NEEDS.objectiveSafetyAndGrowth,
          operator: '==',
          value: 'Yes'
        },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveSafetyAndIncome,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveTaxDeferral,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectivePassAssets,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveAllocToIndexed,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveMedicalExpense,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveIncome,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveDeathBenefit,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveOptions,
        //   operator: '==',
        //   value: 'Yes'
        // },
        // {
        //   section: APP_SECTION.needs,
        //   question: NEEDS.objectiveOther,
        //   operator: '==',
        //   value: 'Yes'
        // },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isRiskToleranceOK,
    condition: {
      OR: [
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceConservative,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceModConservative,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceModerate,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceModAggressive,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceAggressive,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.riskToleranceOther,
          operator: '==',
          value: 'Yes'
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isFedIncomeTaxBracketOK,
    condition: {
      OR: [
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket10,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket12,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket22,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket24,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket32,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket35,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.fedIncomeTaxBracket37,
          operator: '==',
          value: 'Yes'
        },
      ]
    }
  },
  {
    name: PAGES.pageAppNeedsFL,
    condition: {
      AND: [
        {
          name: PAGES.pageAppFinancesFL,
          value: true
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.purchaseReason,
          operator: '!=',
          value: ''
        },
        {
          name: _CONDITION_NAMES.areFinancialObjectivesOK,
          value: true
        },
        {
          name: _CONDITION_NAMES.isRiskToleranceOK,
          value: true
        },
        {
          section: APP_SECTION.needs,
          question: NEEDS.investmentExperience,
          operator: '!=',
          value: ''
        },
      ]
    }
  },
  {
    name: PAGES.pageAppGoalsFL,
    condition: {
      AND: [
        {
          OR: [
            {
              section: APP_SECTION.funds,
              question: FUNDS.replacement,
              operator: '==',
              value: 'No'
            },
            {
              AND: [
                {
                  section: APP_SECTION.funds,
                  question: FUNDS.replacement,
                  operator: '==',
                  value: 'Yes'
                },
                {
                  OR: [
                    {
                      section: APP_SECTION.funds,
                      question: FUNDS.replacementHasPenalty,
                      operator: '==',
                      value: 'No'
                    },
                    {
                      AND: [
                        {
                          section: APP_SECTION.funds,
                          question: FUNDS.replacementHasPenalty,
                          operator: '==',
                          value: 'Yes'
                        },
                        {
                          section: APP_SECTION.funds,
                          question: FUNDS.replacementCharge,
                          operator: '!=',
                          value: ''
                        }
                      ]
                    }
                  ]
                },
              ]
            }
          ]
        },
        {
          section: APP_SECTION.funds,
          question: FUNDS.penaltyFreeAccess,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.funds,
          question: FUNDS.hasReverseMortgage,
          operator: '!=',
          value: ''
        },
        {
          name: _CONDITION_NAMES.isSourceOfFundsOK,
          value: true
        },
        {
          name: _CONDITION_NAMES.isSourceOfFundsNonQualOrIRAOK,
          value: true
        }
      ]
    }
  },
  {
    name: PAGES.pageAppFundsFL,
    condition: {
      AND: [
        {
          section: APP_SECTION.funds,
          question: FUNDS.penaltyFreeAccess,
          operator: '!=',
          value: ''
        },
        {
          OR: [
                {
                  section: APP_SECTION.funds,
                  question: FUNDS.replacement,
                  operator: '==',
                  value: 'No'
                },
                {
                  AND: [
                    {
                      section: APP_SECTION.funds,
                      question: FUNDS.replacement,
                      operator: '==',
                      value: 'Yes'
                    },
                    {
                      OR: [
                        {
                          section: APP_SECTION.funds,
                          question: FUNDS.replacementHasPenalty,
                          operator: '==',
                          value: 'No'
                        },
                        {
                          AND: [
                            {
                              section: APP_SECTION.funds,
                              question: FUNDS.replacementHasPenalty,
                              operator: '==',
                              value: 'Yes'
                            },
                            {
                              section: APP_SECTION.funds,
                              question: FUNDS.replacementCharge,
                              operator: '!=',
                              value: ''
                            }
                          ]
                        }
                      ]
                    },
                  ]
                }
              ]
        },
        {
          section: APP_SECTION.funds,
          question: FUNDS.hasReverseMortgage,
          operator: '!=',
          value: ''
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.didConsent,
    condition: {
      AND: [
        {
          section: APP_SECTION.submission,
          question: APP_SUBMISSION.consentDisclosure,
          operator: '!=',
          value: ''
        },
        {
          section: APP_SECTION.submission,
          question: APP_SUBMISSION.consentSignature,
          operator: '!=',
          value: ''
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isPathA,
    condition: {
      name: _CONDITION_NAMES.isPathB,
      value: false
    }
  },
  { // "PathB means that a call must be scheduled"
    name: _CONDITION_NAMES.isPathB,
    condition: {
      OR: [
        {
          name: _CONDITION_NAMES.isReplacementOrCD,
          value: true
        },
        {
          name: _CONDITION_NAMES.hasOwnerAsTrust,
          value: true
        },
        {
          name: _CONDITION_NAMES.hasJointOwner,
          value: true
        },
        {
          name: _CONDITION_NAMES.hasJointAnnuitant,
          value: true
        },
        {
          name: _CONDITION_NAMES.isRMD,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isPathC,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.isRecommendation,
          value: true
        },
        {
          name: _CONDITION_NAMES.isPathB,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isPartyTheOwner,
    condition: {
      operandLeft: {
        key: PARTY.ownerType
      },
      operator: '==',
      value: OWNER_TYPE.primary
    }
  },
  {
    name: _CONDITION_NAMES.isPartyTheAnnuitant,
    condition: {
      operandLeft: {
        key: PARTY.annuitantType
      },
      operator: '==',
      value: ANNUITANT_TYPE.primary
    }
  },
  {
    name: _CONDITION_NAMES.isPartyTheJointOwner,
    condition: {
      operandLeft: {
        key: PARTY.ownerType
      },
      operator: '==',
      value: OWNER_TYPE.joint
    }
  },
  {
    name: _CONDITION_NAMES.isPartyTheJointAnnuitant,
    condition: {
      operandLeft: {
        key: PARTY.annuitantType
      },
      operator: '==',
      value: ANNUITANT_TYPE.joint
    }
  },
  {
    name: _CONDITION_NAMES.isPartyAnOwner,
    condition: {
      OR: [
        {
          operandLeft: {
            key: PARTY.ownerType
          },
          operator: '==',
          value: OWNER_TYPE.primary
        },
        {
          operandLeft: {
            key: PARTY.ownerType
          },
          operator: '==',
          value: OWNER_TYPE.joint
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isPartyAnAnnuitant,
    condition: {
      OR: [
        {
          operandLeft: {
            key: PARTY.annuitantType
          },
          operator: '==',
          value: ANNUITANT_TYPE.primary
        },
        {
          operandLeft: {
            key: PARTY.annuitantType
          },
          operator: '==',
          value: ANNUITANT_TYPE.joint
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isPartyATrust,
    condition: {
      operandLeft: {
        key: PARTY.entityType
      },
      operator: '==',
      value: ENTITY_TYPE.trust
    }
  },
  {
    name: _CONDITION_NAMES.isPartyAnIndividual,
    condition: {
      operandLeft: {
        key: PARTY.entityType
      },
      operator: '==',
      value: ENTITY_TYPE.individual
    }
  },
  {
    name: _CONDITION_NAMES.isPartyASpouse,
    condition: {
      operandLeft: {
        key: PARTY.relationshipToOwner
      },
      operator: '==',
      value: PARTY_RELATIONSHIPS.spouse
    }
  },
  {
    name: _CONDITION_NAMES.isPartyInFlorida,
    condition: {
      operandLeft: {
        key: PARTY.addressState
      },
      operator: '==',
      value: 'FL'
    }
  },
  {
    name: _CONDITION_NAMES.isPartyAgeGTE72,
    condition: {
      operandLeft: {
        key: PARTY.age
      },
      operator: '>=',
      value: 72
    }
  },
  {
    name: _CONDITION_NAMES.isBeneSurvivor,
    condition: {
      operandLeft: {
        key: BENEFICIARY.uid
      },
      operator: '==',
      value: BENEFICIARY_SURVIVOR_UID
    }
  },
  {
    name: _CONDITION_NAMES.isPartyOK,
    condition: {
      OR: [
          // party as individual
        {
          AND: [
            {
              operandLeft: {
                key: PARTY.entityType,
              },
              operator: '==',
              value: ENTITY_TYPE.individual
            },
            {
              operandLeft: {
                key: PARTY.firstName,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.lastName,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.addressStreet,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.addressCity,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.addressState,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.addressZip,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.idNumber,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.idType,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.idExpiration,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.issuingState,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.dob,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.gender,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.daytimePhone,
              },
              operator: '!=',
              value: ''
            },
            // {
            //   operandLeft: {
            //     key: PARTY.citizenship,
            //   },
            //   operator: '!=',
            //   value: ''
            // },
            {
              operandLeft: {
                key: PARTY.ssnOrTaxId,
              },
              operator: '!=',
              value: ''
            },
            { // Handle occupation for annuitant
              // either the party is NOT an annuitant
              // OR
              // The occupation is not blank AND !other it is OTHER
              OR: [
                {
                  name: _CONDITION_NAMES.isPartyAnAnnuitant,
                  value: false
                },
                {
                  AND: [
                    {
                      operandLeft: {
                        key: PARTY.occupation,
                      },
                      operator: '!=',
                      value: ''
                    },
                    {
                      OR: [
                        {
                          operandLeft: {
                            key: PARTY.occupation,
                          },
                          operator: '!=',
                          value: 'OTHER'
                        },
                        {
                          operandLeft: {
                            key: PARTY.occupationOther,
                          },
                          operator: '!=',
                          value: ''
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              // Handle active duty service person for Owner only.
              // either the party is NOT an owner
              // OR activeDutyServicePerson is not empty
              // Change isPartyAnOwner -> isPartyPrimaryOwner (May have to make one)
              OR: [
                {
                  name: _CONDITION_NAMES.isPartyTheOwner,
                  value: false
                },
                {
                  operandLeft: {
                    key: PARTY.activeDutyServicePerson,
                  },
                  operator: '!=',
                  value: ''
                },
              ]
            },
            {
              operandLeft: {
                key: PARTY.ownerType,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.annuitantType,
              },
              operator: '!=',
              value: ''
            }
          ]
        },
          // party as trust
        {
          AND: [
            {
              operandLeft: {
                key: PARTY.entityType,
              },
              operator: '==',
              value: ENTITY_TYPE.trust
            },
            {
              operandLeft: {
                key: PARTY.trustName,
              },
              operator: '!=',
              value: ''
            },
            {
              operandLeft: {
                key: PARTY.dateOfTrust,
              },
              operator: '!=',
              value: ''
            },
          ]
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isEachPartyOK,
    condition: { // each party must be valid to return true
      FOR_ALL: { // apply same condition to all objects in array
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyOK,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isPartyRelationshipOK,
    condition: {
      AND: [
        {
          operandLeft: {
            key: PARTY.relationshipToOwner
          },
          operator: '!=',
          value: ''
        },
        {
          operandLeft: {
            key: PARTY.relationshipToOwner
          },
          operator: '!=',
          value: PARTY_RELATIONSHIPS.none
        },
        {
          operandLeft: {
            key: PARTY.relationshipToAnnuitant
          },
          operator: '!=',
          value: ''
        },
        {
          operandLeft: {
            key: PARTY.relationshipToAnnuitant
          },
          operator: '!=',
          value: PARTY_RELATIONSHIPS.none
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isEachPartyRelationshipOK,
    condition: { // each party must be valid to return true
      FOR_ALL: { // apply same condition to all objects in array
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyRelationshipOK,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isPartyScenarioValid,
    condition: {
      AND: [
        { // each party must be internally consistent
          name: _CONDITION_NAMES.isEachPartyOK,
          value: true
        },
        { // party relationships must be valid
          name: _CONDITION_NAMES.isEachPartyRelationshipOK,
          value: true
        },
        { // there must be an owner
          name: _CONDITION_NAMES.hasOwner,
          value: true
        },
        { // there must be an annuitant.
          name: _CONDITION_NAMES.hasAnnuitant,
          value: true
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.hasOwner,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyTheOwner,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasOwnerAsTrust,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyATrust,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasOwnerAsIndividual,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyAnIndividual,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasOwnerInFlorida,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyInFlorida,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasOwnerSameAsAnnuitant,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyTheAnnuitant,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasValidOwner,
    condition: {
      FOR_ANY: {
        section: {
          name: APP_SECTION.parties,
          filter: {
            name: _CONDITION_NAMES.isPartyTheOwner,
            value: true
          }
        },
        condition: {
          name: _CONDITION_NAMES.isPartyOK,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasAnnuitant,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyTheAnnuitant,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasJointOwner,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyTheJointOwner,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasJointAnnuitant,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          name: _CONDITION_NAMES.isPartyTheJointAnnuitant,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasJointOwnerAsSpouse,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheJointOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyASpouse,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasSurvivingSpouseForPrimaryBene,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.benes,
        condition: {
          name: _CONDITION_NAMES.isBeneSurvivor,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.needsSurvivingSpouseForPrimaryBene,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.hasOwnerAsIndividual,
          value: true
        },
        {
          name: _CONDITION_NAMES.hasJointOwner,
          value: true
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.canAddOwner,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.hasOwner,
          value: false
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.canAddAnnuitant,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.hasAnnuitant,
          value: false
        },
        {
          name: _CONDITION_NAMES.isIRA,
          value: false
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.canAddJointOwner,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.hasJointOwner,
          value: false
        },
        {
          name: _CONDITION_NAMES.isUsingQualifiedFunds,
          value: false
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.canAddJointAnnuitant,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.hasJointAnnuitant,
          value: false
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.canAddParty,
    condition: {
      OR: [
        {
          name: _CONDITION_NAMES.canAddOwner,
          value: true
        },
        {
          name: _CONDITION_NAMES.canAddAnnuitant,
          value: true
        },
        {
          name: _CONDITION_NAMES.canAddJointOwner,
          value: true
        },
        {
          name: _CONDITION_NAMES.canAddJointAnnuitant,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.hasPayments,
    condition: {
      AND: [
        {
          operandLeft: {
            LENGTH: {
              section: APP_SECTION.products,
            }
          },
          operator: '>',
          value: 0
        },
        {
          FOR_ALL: { // apply same condition to all objects in array
            section: APP_SECTION.products,
            condition: {
              AND: [
                {
                  operandLeft: {
                    LENGTH: {
                      section: MM_PRODUCT_DTO.payments,
                    }
                  },
                  operator: '>',
                  value: 0
                }
              ]
            }
          }
        }
      ]
    }
    
  },
  {
    name: _CONDITION_NAMES.isPaymentScenarioValid,
    condition: {
      AND: [
        { // make sure there is at least one product
          operandLeft: {
            LENGTH: {
              section: APP_SECTION.products,
            }
          },
          operator: '>',
          value: 0
        },
        {
          FOR_ALL: { // For all products make the following checks
            section: APP_SECTION.products,
            condition: {
              AND: [
                { // for all products there is at least one payment
                  operandLeft: {
                    LENGTH: {
                      section: MM_PRODUCT_DTO.payments,
                    }
                  },
                  operator: '>',
                  value: 0
                },
                { // AND for each product the sum of all payments equals the premium
                  operandLeft: {
                    SUM: [
                      {
                        section: MM_PRODUCT_DTO.payments,
                        key: MM_PAYMENT.amount
                      }
                    ]
                  },
                  operator: '==',
                  operandRight: {
                    key: MM_PRODUCT_DTO.premium
                  }
                }
              ]
            }
          }
        }
      ]
    }
    
  },
  {
    name: _CONDITION_NAMES.showMailInfo,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          FOR_ANY: {
            section: MM_PRODUCT_DTO.payments,
            condition: {
              key: 'paymentType',
              operator: '==',
              value: 'check'
            }
          }
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.showConfirmEFT,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          FOR_ANY: {
            section: MM_PRODUCT_DTO.payments,
            condition: {
              key: 'paymentType',
              operator: '==',
              value: 'bank'
            }
          }
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isFL,
    condition: {
      key: STORAGE_KEYS.AppStateAbbr,
      operator: '==',
      value: 'FL'
    }
  },
  {
    name: _CONDITION_NAMES.isFLNonRecommendation,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.isFL,
          value: true
        },
        {
          name: _CONDITION_NAMES.isRecommendation,
          value: false
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.hasMinimumAllocations,
    condition: {
      FOR_ALL: {
        section: APP_SECTION.benes,
        condition: {
          key: BENEFICIARY.allocation,
          operator: '>',
          value: 0
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasPrimaryBenes,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.benes,
        condition: {
          key: BENEFICIARY.beneficiaryType,
          operator: '==',
          value: BENEFICIARY_TYPE.primary
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isPrimaryAllocationComplete,
    condition: {
      operandLeft: {
        section: {
          name: APP_SECTION.benes,
          filter: {
            key: BENEFICIARY.beneficiaryType,
            operator: '==',
            value: BENEFICIARY_TYPE.primary
          }
        },
        SUM: [
          {
            key: BENEFICIARY.allocation
          }
        ]
      },
      operator: '==',
      value: 100
    }
  },
  {
    name: _CONDITION_NAMES.hasContingentBenes,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.benes,
        condition: {
          key: BENEFICIARY.beneficiaryType,
          operator: '==',
          value: BENEFICIARY_TYPE.contingent
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isContingentAllocationComplete,
    condition: {
      operandLeft: {
        section: {
          name: APP_SECTION.benes,
          filter: {
            key: BENEFICIARY.beneficiaryType,
            operator: '==',
            value: BENEFICIARY_TYPE.contingent
          }
        },
        SUM: [
          {
            key: BENEFICIARY.allocation
          }
        ]
      },
      operator: '==',
      value: 100
    }
  },
  {
    name: _CONDITION_NAMES.isTrustValid,
    condition: {
      AND: [
        {
          key: BENEFICIARY_TRUST.entityType,
          operator: '==',
          value: ENTITY_TYPE.trust
        },
        {
          key: BENEFICIARY.firstName,
          operator: '!=',
          value: ''
        },
        {
          key: BENEFICIARY_TRUST.trustName,
          operator: '!=',
          value: ''
        },
        {
          key: BENEFICIARY_TRUST.dateOfTrust,
          operator: '!=',
          value: ''
        },
        {
          key: BENEFICIARY_TRUST.beneficiaryType,
          operator: '!=',
          value: ''
        },
        {
          key: BENEFICIARY_TRUST.allocation,
          operator: '!=',
          value: 0
        },
        {
          key: BENEFICIARY_TRUST.taxId,
          operator: '!=',
          value: ''
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.areAllTrustsValid,
    condition: {
      FOR_ALL: {
        section: {
          name: APP_SECTION.benes,
          filter: {
            key: BENEFICIARY.entityType,
            operator: '==',
            value: ENTITY_TYPE.trust
          }
        },
        condition: {
          name: _CONDITION_NAMES.isTrustValid,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isIndividualBeneValid,
    condition: {
      OR: [
        {
          key: BENEFICIARY.uid,
          operator: '==',
          value: BENEFICIARY_SURVIVOR_UID
        },
        {
          AND: [
            {
              key: BENEFICIARY.entityType,
              operator: '==',
              value: ENTITY_TYPE.individual
            },
            {
              key: BENEFICIARY.firstName,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.lastName,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.dob,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.relationshipToOwner,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.gender,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.beneficiaryType,
              operator: '!=',
              value: ''
            },
            {
              key: BENEFICIARY.allocation,
              operator: '!=',
              value: 0
            }
          ]}
      ],
    }
  },
  {
    name: _CONDITION_NAMES.areAllIndividualsBeneValid,
    condition: {
      FOR_ALL: {
        section: {
          name: APP_SECTION.benes,
          filter: {
            key: BENEFICIARY.entityType,
            operator: '==',
            value: ENTITY_TYPE.individual
          }
        },
        condition: {
          name: _CONDITION_NAMES.isIndividualBeneValid,
          value: true
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.hasValidNumberOfBenes,
    condition: {
      operandLeft: {
        LENGTH: {
          section: APP_SECTION.benes,
        }
      },
      operator: '<=',
      value: 4
    }
  },
  {
    name: _CONDITION_NAMES.isBeneValid,
    condition: {
      OR: [
        {
          name: _CONDITION_NAMES.isTrustValid,
          value: true
        },
        {
          name: _CONDITION_NAMES.isIndividualBeneValid,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isBenesValid,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.areAllTrustsValid,
          value: true
        },
        {
          name: _CONDITION_NAMES.areAllIndividualsBeneValid,
          value: true
        },
        {
          name: _CONDITION_NAMES.hasPrimaryBenes,
          value: true
        },
        {
          name: _CONDITION_NAMES.isPrimaryAllocationComplete,
          value: true
        },
        {
          OR: [
            {
              name: _CONDITION_NAMES.hasContingentBenes,
              value: false
            },
            {
              name: _CONDITION_NAMES.isContingentAllocationComplete,
              value: true
            }
          ]
        },
        {
          name: _CONDITION_NAMES.hasValidNumberOfBenes,
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isReferralCodeValid,
    condition: {
      OR: [
        {
          OR:[
            {
              section: STORAGE_KEYS.AgentInfo,
              key: AGENT_INFO.referralCode,
              operator: 'isValid',
              value: false
            },
            {
              section: STORAGE_KEYS.AgentInfo,
              key: AGENT_INFO.referralCode,
              operator: '==',
              value: ''
            }
          ]
        },
        {
          key: STORAGE_KEYS.AgentInfo,
          operator: 'isValid',
          value: true
        }
      ]
    }
  },
  {
    name: _CONDITION_NAMES.hasValidNetWorth,
    condition: {
      section: APP_SECTION.finances,
      key: FINANCES.netWorth,
      operator: '>=',
      value: FINANCES_NET_WORTH_MIN
    }
  },
  {
    name: _CONDITION_NAMES.canShowAppFinalizePage,
    condition: {
      OR: [
        {
          AND: [
            {page:PAGES.pageAppBenes},
            {
              name: _CONDITION_NAMES.isReplacementOrCD,
              value: true
            },
            {
              name: _CONDITION_NAMES.isBenesValid,
              value: true
            }
          ]
        },
        {
          AND: [
            {page:PAGES.pageAppPayments},
            {
              name: _CONDITION_NAMES.isPaymentScenarioValid,
              value: true
            },
          ]
        }
      ]
    },
  },
  {
    name: _CONDITION_NAMES.isMYAnnuity,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.productFamily,
          },
          operator: '==',
          value: MM_PRODUCT_FAMILY.nfgMA
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.isNoFreeWithdrawal,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.products,
        condition: {
          operandLeft: {
            key: MM_PRODUCT_DTO.freeWithdrawalAmount,
          },
          operator: '==',
          value: 0
        },
      }
    }
  },
  {
    name: _CONDITION_NAMES.isAnyOwnerAgeGTE72,
    condition: {
      FOR_ANY: {
        section: APP_SECTION.parties,
        condition: {
          AND: [
            {
              name: _CONDITION_NAMES.isPartyTheOwner,
              value: true
            },
            {
              name: _CONDITION_NAMES.isPartyAgeGTE72,
              value: true
            }
          ]
        }
      }
    }
  },
  {
    name: _CONDITION_NAMES.isIRARollover,
    condition: {
      OR: [
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsTradIRA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsRothIRA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsSepIRA,
          operator: '==',
          value: 'Yes'
        },
        {
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsSimpleIRA,
          operator: '==',
          value: 'Yes'
        },
      ]
    }
  },
  {
    name: _CONDITION_NAMES.isRMD,
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.isMYAnnuity,
          value: true
        },
        {
          name: _CONDITION_NAMES.isNoFreeWithdrawal,
          value: true
        },
        {
          name: _CONDITION_NAMES.isAnyOwnerAgeGTE72,
          value: true
        },
        {
          name: _CONDITION_NAMES.isIRARollover,
          value: true
        },
      ]
    }
  }
]);
export const CONDITIONS = _CONDITIONS;

export const VALIDATION_REPORT = Object.freeze([
    _CONDITION_NAMES.isRecommendation,
    _CONDITION_NAMES.isFLNonRecommendation,
  _CONDITION_NAMES.knockout,
  _CONDITION_NAMES.knockoutFinances,
  _CONDITION_NAMES.hasPremium4Year,
  _CONDITION_NAMES.hasPremium5Year,
  _CONDITION_NAMES.hasPremium6Year,
  _CONDITION_NAMES.hasPremium7Year,
  _CONDITION_NAMES.isProductCartValid,
  _CONDITION_NAMES.isUsingQualifiedFunds,
  _CONDITION_NAMES.isReplacement,
  _CONDITION_NAMES.isCD,
  _CONDITION_NAMES.isIRA,
  _CONDITION_NAMES.isFL,
  _CONDITION_NAMES.isSourceOfFundsOK,
  _CONDITION_NAMES.isSourceOfFundsNonQualOrIRAOK,
  _CONDITION_NAMES.isSourceOfIncomeOK,
  _CONDITION_NAMES.areFinancialObjectivesOK,
  _CONDITION_NAMES.isRiskToleranceOK,
  // _CONDITION_NAMES.isFedIncomeTaxBracketOK, // 2022.0.20.ADivelbiss - this one was undefined because of commenting the value earlier.
  PAGES.pageAppFinances,
  PAGES.pageAppGoals,
  PAGES.pageAppGoalsFL,
  // PAGES.pageAppFundsFL,
  _CONDITION_NAMES.willStopPayments,
  _CONDITION_NAMES.canAddOwner,
  _CONDITION_NAMES.canAddJointOwner,
  _CONDITION_NAMES.canAddAnnuitant,
  _CONDITION_NAMES.canAddJointAnnuitant,
  _CONDITION_NAMES.isEachPartyOK,
  _CONDITION_NAMES.isEachPartyRelationshipOK,
  _CONDITION_NAMES.isPartyScenarioValid,
  _CONDITION_NAMES.hasOwner,
  _CONDITION_NAMES.hasOwnerAsIndividual,
  _CONDITION_NAMES.hasOwnerAsTrust,
  _CONDITION_NAMES.hasOwnerSameAsAnnuitant,
  _CONDITION_NAMES.hasOwnerInFlorida,
  _CONDITION_NAMES.hasValidOwner,
  _CONDITION_NAMES.hasJointOwner,
  _CONDITION_NAMES.hasAnnuitant,
  _CONDITION_NAMES.hasJointAnnuitant,
  _CONDITION_NAMES.isBenesValid,
  _CONDITION_NAMES.areAllTrustsValid,
  _CONDITION_NAMES.areAllIndividualsBeneValid,
  _CONDITION_NAMES.hasValidNumberOfBenes,
  _CONDITION_NAMES.hasJointOwnerAsSpouse,
  _CONDITION_NAMES.isPaymentScenarioValid,
  _CONDITION_NAMES.isPathA,
  _CONDITION_NAMES.isPathB,
  _CONDITION_NAMES.isPathC,
  _CONDITION_NAMES.didConsent,
  _CONDITION_NAMES.isMYAnnuity,
  _CONDITION_NAMES.isNoFreeWithdrawal,
  _CONDITION_NAMES.isAnyOwnerAgeGTE72,
  _CONDITION_NAMES.isIRARollover,
  _CONDITION_NAMES.isRMD
]);


const _PAGE_FLOW = Object.freeze({
  [PAGES.pageDashboard]: {
    nextPage: PAGES.pageGuestEmail
  },
  [PAGES.pageGuestEmail]: {
    nextPage: PAGES.pageAgentCode,
    prevPage: PAGES.pageDashboard
  },
  [PAGES.pageAgentCode]: {
    condition: {page:PAGES.pageGuestEmail},
    nextPage: PAGES.pageAppKnockout,
    prevPage: PAGES.pageGuestEmail
  },
  [PAGES.pageAppKnockout]: {
    condition: {page:PAGES.pageAgentCode},
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.knockout,
            value: true
          },
          value: PAGES.pageAppKnockoutLanding
        },
        PAGES.pageAppProcessOverview
      ]
    },
    prevPage: PAGES.pageAgentCode
  },
  [PAGES.pageAppKnockoutLanding]: {
    condition: {
      OR: [
        {
          AND: [
            {page: PAGES.pageAppKnockout},
            {
              name: _CONDITION_NAMES.knockout,
              value: true
            }
          ]
        },
        {
          name: _CONDITION_NAMES.knockoutFinances,
          value: true
        },
      ]
    }
  },
  [PAGES.pageAppProcessOverview]: {
    condition: {
      AND: [
        {page:PAGES.pageAppKnockout},
        // {
        //   name: "knockoutAny",
        //   value: false
        // },
      ]
    },
    nextPage: PAGES.pageAppPremium,
    prevPage: PAGES.pageAppKnockout
  },
  [PAGES.pageAppPremium]: {
    condition: {page:PAGES.pageAppProcessOverview},
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.isFL,
            value: true
          },
          value: PAGES.pageAppFinancesFL
        },
        PAGES.pageAppFinances
      ]
    },
    prevPage: PAGES.pageAppProcessOverview
  },
  [PAGES.pageAppFinances]: {
    condition: {
      AND: [
        {page:PAGES.pageAppPremium},
        {
          name: _CONDITION_NAMES.isFL,
          value: false
        },
        {
          name: _CONDITION_NAMES.isProductCartValid,
          value: true
        }
      ]
    },
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.knockoutFinances,
            value: true
          },
          value: PAGES.pageAppKnockoutLanding
        },
        PAGES.pageAppGoals
      ]
    },
    prevPage: PAGES.pageAppPremium
  },
  [PAGES.pageAppFinancesFL]: {
    condition: {
      AND: [
        {page:PAGES.pageAppPremium},
        {
          name: _CONDITION_NAMES.isFL,
          value: true
        },
        {
          name: _CONDITION_NAMES.isProductCartValid,
          value: true
        }
      ]
    },
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.knockoutFinances,
            value: true
          },
          value: PAGES.pageAppKnockoutLanding
        },
        PAGES.pageAppNeedsFL
      ]
    },
    prevPage: PAGES.pageAppPremium
  },
  [PAGES.pageAppNeedsFL]: {
    condition: {
      AND: [
        {page:PAGES.pageAppFinancesFL},
        {
          name: _CONDITION_NAMES.isFL,
          value: true
        },
        {
          name:PAGES.pageAppFinancesFL,
          value: true
        },
        { // knockoutFinances is false
          name: _CONDITION_NAMES.knockoutFinances,
          value: false
        },
      ]
    },
    nextPage: PAGES.pageAppGoalsFL,
    prevPage: PAGES.pageAppFinancesFL
  },
  [PAGES.pageAppGoals]: {
    condition: {
      AND: [
        {page:PAGES.pageAppFinances},
        {
          name: _CONDITION_NAMES.isFL,
          value: false
        },
        { // finances questions are complete
          name: PAGES.pageAppFinances,
          value: true
        },
        { // knockoutFinances is false
          name: _CONDITION_NAMES.knockoutFinances,
          value: false
        },
      ]
    },
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.hasValidOwner,
            value: true
          },
          value: PAGES.pageAppIdOwnerAnnuitantSummary
        },
        PAGES.pageAppIdOwnerAnnuitant
      ]
    },
    prevPage: PAGES.pageAppFinances
  },
  [PAGES.pageAppGoalsFL]: {
    condition: {
      AND: [
        {page:PAGES.pageAppNeedsFL},
        {
          name: PAGES.pageAppNeedsFL,
          value: true
        }
      ]
    },
    prevPage: PAGES.pageAppNeedsFL,
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.hasValidOwner,
            value: true
          },
          value: PAGES.pageAppIdOwnerAnnuitantSummary
        },
        PAGES.pageAppIdOwnerAnnuitant
      ]
    },
  },
  // [PAGES.pageAppFundsFL]: {
  //   condition: {
  //     AND: [
  //         {page:PAGES.pageAppGoalsFL},
  //       {
  //         name: PAGES.pageAppGoalsFL,
  //         value: true
  //       }
  //     ]
  //   },
  //   nextPage: {
  //     conditionalValue: [
  //       {
  //         condition: {
  //           name: _CONDITION_NAMES.hasValidOwner,
  //           value: true
  //         },
  //         value: PAGES.pageAppIdOwnerAnnuitantSummary
  //       },
  //       PAGES.pageAppIdOwnerAnnuitant
  //     ]
  //   },
  //   prevPage: PAGES.pageAppGoalsFL
  // },
  [PAGES.pageAppIdOwnerAnnuitant]: {
    condition:{
      OR: [
        // { // TEST CONDITION THAT CAN PRINT OUT A LOG MESSAGE
        //   section: APP_SECTION.funds,
        //   function: (funds) => {
        //     NassauLog(`funds: ${JSON.stringify(funds,null,2)}`);
        //     return false;
        //   }
        // },
        {
          AND: [
            {
              name: _CONDITION_NAMES.isFL,
              value: false
            },
            {page:PAGES.pageAppGoals},
            {
              name: PAGES.pageAppGoals,
              value: true
            }
          ]
        },
        {
          AND: [
            {
              name: _CONDITION_NAMES.isFL,
              value: true
            },
            {page:PAGES.pageAppGoalsFL},
            {
              name: PAGES.pageAppGoalsFL,
              value: true
            }
          ]
        },
      ]
    },
    nextPage: PAGES.pageAppIdOwnerAnnuitantSummary,
    prevPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.isFL,
            value: true
          },
          value: PAGES.pageAppGoalsFL
        },
        PAGES.pageAppGoals
      ]
    }
  },
  [PAGES.pageAppIdOwnerAnnuitantSummary]: {
    condition:{
      AND: [
        {page: PAGES.pageAppIdOwnerAnnuitant},
        {
          name: _CONDITION_NAMES.hasValidOwner,
          value: true
        }
      ]
    },
    nextPage: PAGES.pageAppBenes,
    prevPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.isFL,
            value: true
          },
          value: PAGES.pageAppGoalsFL
        },
        PAGES.pageAppGoals
      ]
    }
  },
  [PAGES.pageAppBenes]: {
    condition: {
      AND: [
        {page:PAGES.pageAppIdOwnerAnnuitantSummary},
        {
          name: _CONDITION_NAMES.isPartyScenarioValid,
          value: true
        }
      ]
    },
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.isReplacementOrCD,
            value: true
          },
          value: PAGES.pageAppFinalize
        },
        PAGES.pageAppPayments
      ]
    },
    prevPage: PAGES.pageAppIdOwnerAnnuitantSummary
  },
  [PAGES.pageAppPayments]: {
    condition: {
      AND: [
        {
          name: _CONDITION_NAMES.isReplacementOrCD,
          value: false
        },
        {page:PAGES.pageAppBenes},
        {
          name: _CONDITION_NAMES.isBenesValid,
          value: true
        }
      ]
    },
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.showMailInfo,
            value: true
          },
          value: PAGES.pageAppMailCheckInfo
        },
        {
          condition: {
            name: _CONDITION_NAMES.showConfirmEFT,
            value: true
          },
          value: PAGES.pageAppConfirmEFT
        },
        PAGES.pageAppFinalize
      ]
    },
    prevPage: PAGES.pageAppBenes
  },
  [PAGES.pageAppMailCheckInfo]: {
    condition: {page:PAGES.pageAppPayments},
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.showConfirmEFT,
            value: true
          },
          value: PAGES.pageAppConfirmEFT
        },
        PAGES.pageAppFinalize
      ]
    },
    prevPage: PAGES.pageAppPayments
  },
  [PAGES.pageAppConfirmEFT]: {
    condition: {page:PAGES.pageAppPayments},
    nextPage: PAGES.pageAppFinalize,
    prevPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.showMailInfo,
            value: true
          },
          value: PAGES.pageAppMailCheckInfo
        },
        PAGES.pageAppPayments
      ]
    }
  },
  [PAGES.pageAppFinalize]: {
    condition: {
      name: _CONDITION_NAMES.canShowAppFinalizePage,
      value: true
    },
    nextPage: PAGES.pageAppSubmitApp,
    prevPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.showConfirmEFT,
            value: true
          },
          value: PAGES.pageAppConfirmEFT
        },
        {
          condition: {
            name: _CONDITION_NAMES.showMailInfo,
            value: true
          },
          value: PAGES.pageAppMailCheckInfo
        },
        PAGES.pageAppPayments
      ]
    }
  },

  [PAGES.pageAppSubmitApp]: {
    condition: {page:PAGES.pageAppFinalize},
    nextPage: {
      conditionalValue: [
        {
          condition: {
            name: _CONDITION_NAMES.isPathC,
            value: true
          },
          value: PAGES.pageAppPartialCompleteAR
        },
        {
          condition: {
            name: _CONDITION_NAMES.isPathB,
            value: true
          },
          value: PAGES.pageAppPartialComplete
        },
        PAGES.pageAppCompleted
      ]
    }
  },
  [PAGES.pageAppPartialCompleteAR]:{},
  [PAGES.pageAppPartialComplete]: {},
  [PAGES.pageAppCompleted]: {}
});
export const PAGE_FLOW = _PAGE_FLOW;

// 2021.07.08.ADivelbiss - Adding a question pool to help support FL and multiple pages.
// These questions are for dynamically generated pages.
export const QUESTIONS = [
    // Questions in use
  {
    name: "sourceOfFunds",
    label: "What is the source of premium for this annuity?",
    info: {
      content: "If multiple payments are funding this annuity, please select all applicable sources of funds below.",
    },
    footnote: {
      text: 'Check all that apply',
      placement: 'Label',
      justification: 'center',
      info: {
        content: "Based on the source of funds you selected to fund the annuity some of the payment options are disabled.",
      },
    },
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsStocks,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsCD,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.goals,
                    question: GOALS.answerIsReplacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsFA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.goals,
                question: GOALS.answerIsReplacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.goals,
                    question: GOALS.answerIsReplacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsVA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.goals,
                question: GOALS.answerIsReplacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.goals,
                    question: GOALS.answerIsReplacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsIA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.goals,
                question: GOALS.answerIsReplacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFunds401K,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsPSP,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsCS,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.goals,
                    question: GOALS.answerIsReplacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsLI,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.goals,
                question: GOALS.answerIsReplacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsPP,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.goals,
                    question: GOALS.answerIsReplacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsDP,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.goals,
                question: GOALS.answerIsReplacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsMM,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "Stock/Bonds/Mutual Funds",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsStocks,
          isSecurity: true
        },
        {
          label: "CD",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsCD,
          isSecurity: false
        },
        {
          label: "Fixed Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsFA,
          isSecurity: false,
          enableCondition: {
            section: APP_SECTION.goals,
            question: GOALS.answerIsReplacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Variable Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsVA,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.goals,
            question: GOALS.answerIsReplacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Indexed Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsIA,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.goals,
            question: GOALS.answerIsReplacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "401k",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFunds401K,
          isSecurity: true
        },
        {
          label: "Profit Sharing Plan",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsPSP,
          isSecurity: false
        },
        {
          label: "Checking/Savings",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsCS,
          isSecurity: false
        },
        {
          label: "Life Insurance",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsLI,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.goals,
            question: GOALS.answerIsReplacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Pension Plan",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsPP,
          isSecurity: true
        },
        {
          label: "Death Proceeds",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsDP,
          isSecurity: false,
          // 2022.06.27.ADivelbiss - Allow death proceeds based on compliance feedback this date.
          // enableCondition: {
          //   section: APP_SECTION.goals,
          //   question: GOALS.answerIsReplacement,
          //   operator: '==',
          //   value: 'Yes'
          // }
        },
        {
          label: "Money Market",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsMM,
          isSecurity: true
        },
      ],
    }
  },
    
    // Non-Qualified or IRA Questions
  {
    name: "sourceOfFundsNonQualOrIRA",
    label: "Select a Non-Qualified or IRA Plan",
    info: {
      content: "Can you use this contract with an IRA? Yes, this contract can be used with Individual Retirement Annuities (IRAs), including traditional IRAs and Roth IRAs.  However, an annuity contract issued as part of a qualified retirement plan or IRA does not receive any tax benefits in addition to those provided under such qualified retirement plan or IRA without an annuity contract."
    },
    section: APP_SECTION.finances,
    inputType: QUESTION_INPUT_TYPE.radioCheckbox,
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFunds1035,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsNewPurchase,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsTradIRA,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsRothIRA,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsSepIRA,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsSimpleIRA,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "1035 Exchange",
          key: FINANCES.sourceOfFunds1035
        },
        {
          label: "New Purchase",
          key: FINANCES.sourceOfFundsNewPurchase
        },
        {
          label: "Traditional IRA",
          key: FINANCES.sourceOfFundsTradIRA
        },
        {
          label: "Roth IRA",
          key: FINANCES.sourceOfFundsRothIRA
        },
        {
          label: "SEP IRA",
          key: FINANCES.sourceOfFundsSepIRA
        },
        {
          label: "Simple IRA",
          key: FINANCES.sourceOfFundsSimpleIRA
        },
      ]
    },
    questions: [
      {
        name: 'sourceOfFundsSepIRAName',
        key: FINANCES.sourceOfFundsSepIRAName,
        anchorTo: FINANCES.sourceOfFundsSepIRA,
        category: QUESTION_CATEGORY.financial,
        label: 'Plan Name:',
        inputType: QUESTION_INPUT_TYPE.text,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.sourceOfFundsSepIRA,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: []
        }
      },
      {
        name: 'sourceOfFundsSepIRATaxId',
        key: FINANCES.sourceOfFundsSepIRATaxID,
        anchorTo: FINANCES.sourceOfFundsSepIRA,
        category: QUESTION_CATEGORY.financial,
        label: 'Tax ID:',
        inputType: QUESTION_INPUT_TYPE.text,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.sourceOfFundsSepIRA,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: []
        }
      },
      {
        name: 'sourceOfFundsSimpleIRAName',
        key: FINANCES.sourceOfFundsSimpleIRAName,
        anchorTo: FINANCES.sourceOfFundsSimpleIRA,
        category: QUESTION_CATEGORY.financial,
        label: 'Plan Name:',
        inputType: QUESTION_INPUT_TYPE.text,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.sourceOfFundsSimpleIRA,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: []
        }
      },
      {
        name: 'sourceOfFundsSimpleIRATaxId',
        key: FINANCES.sourceOfFundsSimpleIRATaxID,
        anchorTo: FINANCES.sourceOfFundsSimpleIRA,
        category: QUESTION_CATEGORY.financial,
        label: 'Tax ID:',
        inputType: QUESTION_INPUT_TYPE.text,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.sourceOfFundsSimpleIRA,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: []
        }
      }
    ]
  },
    
    // Non-FL Knockout questions
  {
    name: "isUSCitizen",
    category: QUESTION_CATEGORY.knockout,
    label: {
      text: "Are you a U.S. citizen?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: ID_VERIFY.citizenship,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: ID_VERIFY.citizenship,
        }
      ],
    },
    questions: []
  },
  {
    name: "isApplicantImpaired",
    category: QUESTION_CATEGORY.knockout,
    label: {
      text: "Do you or anyone else who is applying for this annuity currently reside in a hospital, hospice, nursing home or assisted living, or do you have any terminal illness, or do you have any neurological cognitive impairment such as dementia, Alzheimer’s or Parkinson’s disease?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerApplicantImpaired,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerApplicantImpaired,
        }
      ],
    },
    questions: []
  },
  {
    name: "isUsingReverseMortgage",
    category: QUESTION_CATEGORY.knockout,
    label: {
      text: "Do you plan to pay for this with proceeds from a reverse mortgage?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerUsingReverseMortgage,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerUsingReverseMortgage,
        }
      ],
    },
    questions: []
  },
    
    // FL Knockout Questions
  {
    name: "assistedLivingFL",
    label: {
      text: "Do you or any proposed Owner, Annuitant or Covered Person currently reside in a hospital, hospice facility or nursing home or participate in any assisted living program?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.general,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GENERAL.assistedLiving
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GENERAL.assistedLiving
        }
      ]
    }
  },
  {
    name: "terminalIllnessFL",
    label: {
      text: "Have you or any proposed Owner, Annuitant or Covered Person been diagnosed with a terminal illness by a licensed medical professional or health care provider?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.general,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GENERAL.terminalIllness
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GENERAL.terminalIllness
        }
      ]
    }
  },
  {
    name: "memoryDiseaseFL",
    label: {
      text: "In the past 5 years, have you been diagnosed, treated, tested positive for, taken medications or been prescribed medications for, or been given medical advice by a licensed physician or other health care provider for dementia, Alzheimer's disease, Parkinson's disease or other neurological disorder?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.general,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GENERAL.memoryDisease
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GENERAL.memoryDisease
        }
      ]
    }
  },
  {
    name: "expectLumpSumPaymentsFL",
    label: {
      text: "Do you expect to take any lump sum payments out of this annuity that will incur a penalty?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.funds,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FUNDS.expectLumpSumPayments,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FUNDS.expectLumpSumPayments,
        }
      ],
    },
    // 2022.03.24.ADivelbiss - sub-question not needed.
    // questions: [
    //   {
    //     name: "expectLumpSumPaymentsExp",
    //     key: FUNDS.expectLumpSumPaymentsExp,
    //     category: QUESTION_CATEGORY.financial,
    //     label: "Please explain:",
    //     inputType: QUESTION_INPUT_TYPE.textArea,
    //     visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    //     visualSpacing: 1,
    //     visibilityCondition: {
    //       key: FUNDS.expectLumpSumPayments,
    //       operator: '==',
    //       value: QUESTION_RESPONSE_VALUE.yes
    //     },
    //     requirementConditions: true,
    //     response: {
    //       constraints: [
    //         {
    //           rows: 3,
    //           cols: 'auto',
    //           maxLength: '300'
    //         }
    //       ]
    //     }
    //   }
    // ]
  },
  {
    name: "isUsingReverseMortgageFL",
    category: QUESTION_CATEGORY.knockout,
    label: {
      text: "Are you using proceeds from a reverse mortgage to fund this annuity?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerUsingReverseMortgage,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerUsingReverseMortgage,
        }
      ],
    },
    questions: []
  },

    // Financial Questions
  {
    name: "annualIncome",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Annual Income",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoAnnualIncome,
    },
    section: APP_SECTION.finances,
    key: 'incomeAnnual',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "annualIncomeFL",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Annual Household Income",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoAnnualIncome,
    },
    section: APP_SECTION.finances,
    key: 'incomeAnnual',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "annualApplicantIncomeFL",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Annual Income",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoApplicantAnnualIncome,
    },
    section: APP_SECTION.finances,
    key: 'incomeApplicantAnnual',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "monthlyExpenses",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Monthly Expenses",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoMonthlyExpenses,
    },
    section: APP_SECTION.finances,
    key: 'expensesMonthly',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "annualExpenses",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Annual Household Expenses",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoAnnualExpenses,
    },
    section: APP_SECTION.finances,
    key: 'expensesAnnual',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "netWorth",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Net Worth",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoNetWorth,
    },
    section: APP_SECTION.finances,
    key: 'netWorth',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "netWorthFL",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Existing Assets (Total Net Worth)",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoNetWorth,
    },
    section: APP_SECTION.finances,
    key: 'netWorth',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "liquidAssets",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Liquid Assets",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoLiquidAssets,
    },
    section: APP_SECTION.finances,
    key: 'liquidAssets',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "liquidAssetsFL",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Existing Liquid Net Worth",
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      },
      containerClassname: {
        orientationVertical: 'pb-1'
      }
    },
    info: {
      content: Resources.Strings.Finances_InfoLiquidAssets,
    },
    section: APP_SECTION.finances,
    key: 'liquidAssets',
    inputType: QUESTION_INPUT_TYPE.currency,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 6,
        displayNarrow: 12
      },
      className: 'alt-form-control',
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "ageRange",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: Resources.Strings.Finances_AgeRange,
      colSpan: {
        displayWide: 4,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      },
      constraints: [
        {
          label: "Less than 65",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.ageGTE65,
        },
        {
          label: "65 or over",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.ageGTE65,
        }
      ],
    },
    questions: []
  },
  {
    name: "hasOtherContracts",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: 'Do you have other annuity contracts or insurance policies?',
      justification: 'center'
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    requirementConditions: true,
    response: {
      colSpan: 8,
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.otherContracts,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.otherContracts,
        }
      ],
    },
    questions: []
  },

  {
    name: "needsEarlyAccess",
    category: QUESTION_CATEGORY.goals,
    label: {
      text: "Do you anticipate needing to access monies from this contract above the maximum allowable penalty-free withdrawal amounts?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      },
    },
    info: {
      content: "Depending on the product version you selected, the contract may or may not allow a penalty-free withdrawal amount. Withdrawals above the free withdrawal amount may be subject to a surrender charge and market value adjustment, which can result in a loss of your principal. Withdrawals are subject to income taxes and if taken prior to age 59 1⁄2, a 10% IRS penalty may also apply.",
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerNeedEarlyAccessToMoney,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerNeedEarlyAccessToMoney,
        }
      ],
    },
    questions: []
  },
  {
    name: "isReplacement",
    category: QUESTION_CATEGORY.goals,
    label: {
      text: "Will this annuity replace any existing insurance policy or annuity contract?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      },
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerIsReplacement,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerIsReplacement,
        }
      ],
    },
    questions: []
  },
  {
    name: "willStopPayments",
    category: QUESTION_CATEGORY.goals,
    label: {
      text: "Do you plan to stop making premium payments, surrendering, or terminating your existing contract/policy, or do you plan to use funds from your existing contract/policy to pay premiums on the new contract/policy?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      },
    },
    info: {
      content: "Regulators want us to pay special attention when consumers cancel, lapse or take partial withdrawals from one life insurance policy / annuity contract to purchase another. If you are planning to change coverage or use money from other contracts/policies to fund this one, please answer yes.",
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerStopPaymentOnOtherPolicies,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerStopPaymentOnOtherPolicies,
        }
      ],
    },
    questions: []
  },
  {
    name: "hasSourceOfFundsPenalty",
    category: QUESTION_CATEGORY.goals,
    label: {
      text: "Is there a surrender charge, bonus recapture charge, loss of value, or any other penalty or fee associated with the source of funds you plan to use to purchase this annuity?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      },
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GOALS.answerSourceOfFundsPenalty,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GOALS.answerSourceOfFundsPenalty,
        }
      ],
    },
    questions: []
  },
  {
    name: "isConsentingToDisclosure",
    key: APP_SUBMISSION.consentDisclosure,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: [
        {
          label: 'I consent to electronically receive required fixed annuity disclosures',
        }
      ]
    }
  },
  {
    name: "isConsentingToSignElectronically",
    key: APP_SUBMISSION.consentSignature,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: [
        {
          label: 'I consent to sign my annuity application electronically',
        }
      ]
    }
  },
    
  // Questions for Florida
  {
    name: 'sourceOfIncomeFL',
    category: QUESTION_CATEGORY.financial,
    label: {
      text: 'Source of Income:',
      justification: 'center'
    },
    footnote: {
      text: 'Check all that apply',
      placement: 'Label',
      justification: 'center'
    },
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    requirementConditions: [
      {
        AND: [
          {
            key: FINANCES.sourceOfIncomeWages,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomePension,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomeSS,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomeInvestment,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomeRMD,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncome72TQ,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomeDisability,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: FINANCES.sourceOfIncomeOther,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "Current Wages",
          key: FINANCES.sourceOfIncomeWages,
        },
        {
          label: "Pension Plan",
          key: FINANCES.sourceOfIncomePension,
        },
        {
          label: "Social Security",
          key: FINANCES.sourceOfIncomeSS,
        },
        {
          label: "Investment Income",
          key: FINANCES.sourceOfIncomeInvestment,
        },
        {
          label: "Required Minimum Distribution (RMD)",
          key: FINANCES.sourceOfIncomeRMD,
        },
        {
          label: "72 (t)/(q)",
          key: FINANCES.sourceOfIncome72TQ,
        },
        {
          label: "Disability",
          key: FINANCES.sourceOfIncomeDisability,
        },
        {
          label: "Other",
          key: FINANCES.sourceOfIncomeOther,
        }
      ]
    },
    questions: [
      {
        name: "sourceOfIncomeFLOtherText",
        key: FINANCES.sourceOfIncomeOtherExp,
        anchorTo: FINANCES.sourceOfIncomeOther,
        category: QUESTION_CATEGORY.financial,
        label: "Please list:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.sourceOfIncomeOther,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "annuityOwnership",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Do you currently own any annuities?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.annuityOwnership,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.annuityOwnership,
        }
      ],
    },
    questions: [
      {
        name: "annuityOwnershipExp",
        key: FINANCES.annuityOwnershipExp,
        category: QUESTION_CATEGORY.financial,
        label: "Please list:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.annuityOwnership,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "lifeOwnership",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Do you currently own life insurance?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    } ,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.lifeOwnership,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.lifeOwnership,
        }
      ],
    },
    questions: [
      {
        name: "lifeOwnershipExp",
        key: FINANCES.lifeOwnershipExp,
        category: QUESTION_CATEGORY.financial,
        label: "Please list:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: {
          displayWide: QUESTION_VISUAL_ORIENTATION.vertical,
          displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
        },
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.lifeOwnership,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "incomeCoversExpenses",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Does your income cover all your living expenses including medical?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.incomeCoversExpenses,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.incomeCoversExpenses,
        }
      ]
    },
  },
  {
    name: "livingExpensesChange",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Do you expect changes to your living expenses?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.livingExpensesChange,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.livingExpensesChange,
        }
      ],
    },
    questions: [
      {
        name: "livingExpensesChangeExp",
        key: FINANCES.livingExpensesChangeExp,
        category: QUESTION_CATEGORY.financial,
        label: "If yes, please explain:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.livingExpensesChange,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "medicalExpensesChange",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Do you anticipate changes in your out-of-pocket medical expenses?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.medicalExpensesChange,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.medicalExpensesChange,
        }
      ],
    },
    questions: [
      {
        name: "medicalExpensesChangeExp",
        key: FINANCES.medicalExpensesChangeExp,
        category: QUESTION_CATEGORY.financial,
        label: "If yes, please explain:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.medicalExpensesChange,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "incomeCoversExpensesInSurrenderPeriod",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Is your income sufficient to cover future changes in your living and/or out-of-pocket medical expenses during the surrender charge period?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.incomeCoversExpensesInSurrenderPeriod,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.incomeCoversExpensesInSurrenderPeriod,
        }
      ],
    },
    questions: [
      {
        name: "incomeCoversExpensesInSurrenderPeriodExp",
        key: FINANCES.incomeCoversExpensesInSurrenderPeriodExp,
        category: QUESTION_CATEGORY.financial,
        label: "If no, please explain:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: FINANCES.incomeCoversExpensesInSurrenderPeriod,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.no
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "hasEmergencyFund",
    category: QUESTION_CATEGORY.financial,
    label: {
      text: "Do you have an emergency fund for unexpected expenses?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FINANCES.hasEmergencyFund,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FINANCES.hasEmergencyFund,
        }
      ],
    }
  },

  {
    name: 'purchaseReasonFL',
    label: {
      text: 'Why are you purchasing this annuity?',
      justification: 'center'
    },
    section: APP_SECTION.needs,
    key: NEEDS.purchaseReason,
    inputType: QUESTION_INPUT_TYPE.textArea,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    requirementConditions: true,
    response: {
      constraints: [
        {
          rows: 3,
          cols: 'auto',
          maxLength: '300'
        }
      ]
    }
  },
  {
    name: "financialObjectivesFL",
    label: {
      text: "What are your financial objectives for this purchase?",
      justification: 'center'
    },
    footnote: {
      text: 'Check all that apply',
      placement: 'Label',
      justification: 'center'
    },
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    category: QUESTION_CATEGORY.needs,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [ // 2022.04.27.ADivelbiss - in FL either objectivePotentialGrowth or objectiveSafetyAndGrowth is required
          {
            key: NEEDS.objectivePotentialGrowth,
            operator: '!=',
            value: 'Yes'
          },
          // {
          //   key: NEEDS.objectivePreservation,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          {
            key: NEEDS.objectiveSafetyAndGrowth,
            operator: '!=',
            value: 'Yes'
          },
          // {
          //   key: NEEDS.objectiveSafetyAndIncome,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveTaxDeferral,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectivePassAssets,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveAllocToIndexed,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveMedicalExpense,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveIncome,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveDeathBenefit,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveOptions,
          //   operator: '!=',
          //   value: 'Yes'
          // },
          // {
          //   key: NEEDS.objectiveOther,
          //   operator: '!=',
          //   value: 'Yes'
          // }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "Growth (long term)",
          key: NEEDS.objectivePotentialGrowth
        },
        {
          label: "Preservation of Principal",
          key: NEEDS.objectivePreservation
        },
        {
          label: "Safety of Principal and Growth",
          key: NEEDS.objectiveSafetyAndGrowth
        },
        {
          label: "Safety of Principal and Income",
          key: NEEDS.objectiveSafetyAndIncome
        },
        {
          label: "Tax deferral of growth",
          key: NEEDS.objectiveTaxDeferral
        },
        {
          label: "Pass assets to a beneficiary or beneficiaries at death",
          key: NEEDS.objectivePassAssets
        },
        {
          label: "Income",
          key: NEEDS.objectiveIncome
        },
        {
          label: "Death Benefit",
          key: NEEDS.objectiveDeathBenefit
        },
        {
          label: "Minimum guaranteed rate of interest",
          key: NEEDS.objectiveMinGRate
        },
        {
          label: "Other",
          key: NEEDS.objectiveOther,
        },
      ],
    },
    questions: [
      {
        name: "financialObjectivesFLOtherText",
        key: NEEDS.objectiveOtherExp,
        anchorTo: NEEDS.objectiveOther,
        category: QUESTION_CATEGORY.needs,
        label: "",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: NEEDS.objectiveOther,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "riskToleranceFL",
    label: {
      text: "Describe your risk tolerance:",
      justification: 'center'
    },
    footnote: {
      text: 'Check all that apply',
      placement: 'Label',
      justification: 'center'
    },
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    category: QUESTION_CATEGORY.needs,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [
          {
            key: NEEDS.riskToleranceConservative,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.riskToleranceModConservative,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.riskToleranceModerate,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.riskToleranceModAggressive,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.riskToleranceAggressive,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.riskToleranceOther,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "Conservative",
          key: NEEDS.riskToleranceConservative
        },
        {
          label: "Moderately Conservative",
          key: NEEDS.riskToleranceModConservative
        },
        {
          label: "Moderate",
          key: NEEDS.riskToleranceModerate
        },
        {
          label: "Moderate Aggressive",
          key: NEEDS.riskToleranceModAggressive
        },
        {
          label: "Aggressive",
          key: NEEDS.riskToleranceAggressive
        },
        {
          label: "Other",
          key: NEEDS.riskToleranceOther,
        }
      ],
    },
    questions: [
      {
        name: "riskToleranceFLOtherText",
        key: NEEDS.riskToleranceOtherText,
        anchorTo: NEEDS.riskToleranceOther,
        category: QUESTION_CATEGORY.needs,
        label: "Please list:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: NEEDS.riskToleranceOther,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  {
    name: "riskToleranceCommentsFL",
    key: NEEDS.riskToleranceComments,
    label: "Comments:",
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.text,
    category: QUESTION_CATEGORY.needs,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: []
    }
  },
  {
    name: "fedIncomeTaxBracketFL",
    label: {
      text: "Federal Income Tax Bracket:",
      justification: 'center'
    },footnote: {
      text: 'Including income to be provided by this annuity',
      placement: 'Label',
      justification: 'center'
    },
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    category: QUESTION_CATEGORY.needs,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [
          {
            key: NEEDS.fedIncomeTaxBracket10,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket12,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket22,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket24,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket32,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket35,
            operator: '!=',
            value: 'Yes'
          },
          {
            key: NEEDS.fedIncomeTaxBracket37,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      constraints: [
        {
          label: "10%",
          key: NEEDS.fedIncomeTaxBracket10
        },
        {
          label: "12%",
          key: NEEDS.fedIncomeTaxBracket12
        },
        {
          label: "22%",
          key: NEEDS.fedIncomeTaxBracket22
        },
        {
          label: "24%",
          key: NEEDS.fedIncomeTaxBracket24
        },
        {
          label: "32%",
          key: NEEDS.fedIncomeTaxBracket32
        },
        {
          label: "35%",
          key: NEEDS.fedIncomeTaxBracket35
        },
        {
          label: "37%",
          key: NEEDS.fedIncomeTaxBracket37
        },
      ]
    }
  },
  {
    name: "investmentExperienceFL",
    key: NEEDS.investmentExperience,
    label: "Describe your investment experience by type and length of time:",
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.text,
    category: QUESTION_CATEGORY.needs,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: []
    }
  },
  {
    name: "incomeRiderWaitYearsFL",
    label: {
      text: "If you selected an income rider, how many years do you expect to wait before taking your first payment?",
      colSpan: {
        displayWide: 7,
        displayNarrow: 12
      }
    },
    key: NEEDS.incomeRiderWaitYears,
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.select,
    category: QUESTION_CATEGORY.needs,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: [
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"},
        {value: 6, label: "6"},
        {value: 7, label: "7"},
        {value: 8, label: "8"},
        {value: 9, label: "9"},
        {value: 10, label: "10"},
        {value: 11, label: "11 or More"},
      ]
    }
  },
  {
    name: "withdrawalImpactFL",
    label: {
      text: "Did your producer explain the impact that withdrawals may have on your rider benefits (including Required Minimum Distributions, Penalty Free Withdrawals)?",
      colSpan: {
        displayWide: 7,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.needs,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: NEEDS.withdrawalImpact
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: NEEDS.withdrawalImpact
        },
        {
          label: "N/A",
          value: QUESTION_RESPONSE_VALUE.notApplicable,
          key: NEEDS.withdrawalImpact
        }
      ]
    }
  },
  {
    name: "discussCareProtectionBenefitFL",
    label: {
      text: "If you selected the Care Protection benefit, did you and your producer discuss the material feature of the benefit, including eligibility requirements?",
      colSpan: {
        displayWide: 7,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.needs,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      justification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: NEEDS.discussCareProtectionBenefit
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: NEEDS.discussCareProtectionBenefit
        },
        {
          label: "N/A",
          value: QUESTION_RESPONSE_VALUE.notApplicable,
          key: NEEDS.discussCareProtectionBenefit
        }
      ]
    }
  },
  {
    name: "explainStrategyFeeFL",
    label: {
      text: "If you selected an Indexed Account with a Strategy Fee, did your producer explain the potential impact the Strategy Fee may have on your benefits?",
      colSpan: {
        displayWide: 7,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.needs,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      justification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: NEEDS.explainStrategyFee
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: NEEDS.explainStrategyFee
        },
        {
          label: "N/A",
          value: QUESTION_RESPONSE_VALUE.notApplicable,
          key: NEEDS.explainStrategyFee
        }
      ]
    }
  },

  {
    name: "sourceOfFundsForPurchaseFL",
    label: {
      text: "What is the source of the funds for the purchase of the proposed annuity?",
      justification: 'center'
    },
    inputType: QUESTION_INPUT_TYPE.multiCheckbox,
    footnote: {
      text: 'Check all that apply',
      placement: 'Label',
      justification: 'center',
      info: {
        content: "Based on the source of funds you selected to fund the annuity some of the payment options are disabled.",
      },
    },
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [
      {
        AND: [
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsStocks,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsCD,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.funds,
                    question: FUNDS.replacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsFA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.funds,
                question: FUNDS.replacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.funds,
                    question: FUNDS.replacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsVA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.funds,
                question: FUNDS.replacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.funds,
                    question: FUNDS.replacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsIA,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.funds,
                question: FUNDS.replacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFunds401K,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsPSP,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsCS,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.funds,
                    question: FUNDS.replacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsLI,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.funds,
                question: FUNDS.replacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsPP,
            operator: '!=',
            value: 'Yes'
          },
          {
            OR: [
              {
                AND: [
                  {
                    section: APP_SECTION.funds,
                    question: FUNDS.replacement,
                    operator: '==',
                    value: 'Yes'
                  },
                  {
                    section: APP_SECTION.finances,
                    key: FINANCES.sourceOfFundsDP,
                    operator: '!=',
                    value: 'Yes'
                  }
                ]
              },
              {
                section: APP_SECTION.funds,
                question: FUNDS.replacement,
                operator: '!=',
                value: 'Yes'
              }
            ]
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsMM,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: APP_SECTION.finances,
            key: FINANCES.sourceOfFundsTSP,
            operator: '!=',
            value: 'Yes'
          }
        ]
      }
    ],
    response: {
      justification: 'center',
      colCount: {
        displayWide: 2,
        displayNarrow: 1
      }, //USE FINANCES
      constraints: [
        {
          label: "401K",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFunds401K,
          isSecurity: true
        },
        {
          label: "Death Proceeds",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsDP,
          isSecurity: false,
          // 2022.06.27.ADivelbiss - Allow death proceeds based on compliance feedback this date.
          // enableCondition: {
          //   section: APP_SECTION.funds,
          //   question: FUNDS.replacement,
          //   operator: '==',
          //   value: 'Yes'
          // }
        },
        {
          label: "Life Insurance",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsLI,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.funds,
            question: FUNDS.replacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Profit Sharing Plan",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsPSP,
          isSecurity: false
        },
        {
          label: "Certificate of Deposit",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsCD,
          isSecurity: false
        },
        {
          label: "Fixed Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsFA,
          isSecurity: false,
          enableCondition: {
            section: APP_SECTION.funds,
            question: FUNDS.replacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Money Market",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsMM,
          isSecurity: true,
        },
        {
          label: "Stocks/Bonds/Mutual Funds",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsStocks,
          isSecurity: true
        },
        {
          label: "Checking/Savings",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsCS,
          isSecurity: false
        },
        {
          label: "Indexed Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsIA,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.funds,
            question: FUNDS.replacement,
            operator: '==',
            value: 'Yes'
          }
        },
        {
          label: "Pension Plan",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsPP,
          isSecurity: true
        },
        {
          label: "Thrift Savings Plan",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsTSP,
          isSecurity: false
        },
        {
          label: "Variable Annuity",
          section: APP_SECTION.finances,
          key: FINANCES.sourceOfFundsVA,
          isSecurity: true,
          enableCondition: {
            section: APP_SECTION.funds,
            question: FUNDS.replacement,
            operator: '==',
            value: 'Yes'
          }
        }
      ]
    }
  },
  {
    name: "penaltyFreeAccessFL",
    key: FUNDS.penaltyFreeAccess,
    label: {
      text: "How many years from today will you need access to your funds without a penalty?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    inputType: QUESTION_INPUT_TYPE.select,
    category: QUESTION_CATEGORY.funds,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    requirementConditions: true,
    response: {
      constraints: [
        {value: '0', label: 'Less than 1 year'},
        {value: '1', label: '1'},
        {value: '2', label: '2'},
        {value: '3', label: '3'},
        {value: '4', label: '4'},
        {value: '5', label: '5'},
        {value: '6', label: '6'},
        {value: '7', label: '7'},
        {value: '8', label: '8'},
        {value: '9', label: '9'},
        {value: '10', label: '10'},
        {value: '11', label: '11 years or more'}
      ],
    }
  },
  {
    name: "replacementFL",
    label: {
      text: "Will the proposed annuity replace any product?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    info: {
      content: "Regulators want us to pay special attention when consumers cancel, lapse, or take partial withdrawals from one life insurance policy/annuity contract to purchase another. If you are planning to change coverage, stop making premium payments, or use money from other contracts/policies to fund this annuity, please answer yes.",
    },
    category: QUESTION_CATEGORY.funds,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FUNDS.replacement,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FUNDS.replacement,
        }
      ],
    },
    questions: [
      {
        name: "hasChargeWithReplacementFL",
        label: {
          text: "If yes, will you pay a penalty or other charge to obtain these funds?",
          colSpan: {
            displayWide: 8,
            displayNarrow: 12
          },
          icon: 'chevron-right'
        },
        placement: 'Question',
        category: QUESTION_CATEGORY.funds,
        inputType: QUESTION_INPUT_TYPE.radio,
        visualOrientation: {
          displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
          displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
        },
        visibilityCondition: {
          key: FUNDS.replacement,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          justification: 'center',
          labelJustification: 'center',
          constraints: [
            {
              label: "Yes",
              value: QUESTION_RESPONSE_VALUE.yes,
              key: FUNDS.replacementHasPenalty,
            },
            {
              label: "No",
              value: QUESTION_RESPONSE_VALUE.no,
              key: FUNDS.replacementHasPenalty,
            }
          ],
        },
        questions: [
          {
            name: "replacementFLExp",
            key: 'replacementCharge',
            label: {
              text: "If yes, the amount of the charge or penalty:",
              textClassname: {
                orientationHorizontal: 'question-label-pl-2'
              },
              colSpan: {
                displayWide: 8,
                displayNarrow: 12
              },
              icon: 'chevron-right'
            },
            placement: 'Question',
            category: QUESTION_CATEGORY.funds,
            inputType: QUESTION_INPUT_TYPE.currency,
            visualOrientation: {
              displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
              displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
            },
            visibilityCondition: {
              key: FUNDS.replacementHasPenalty,
              operator: '==',
              value: QUESTION_RESPONSE_VALUE.yes
            },
            requirementConditions: true,
            response: {
              constraints: [],
            }
          }
        ]
      }
    ]
  },
  {
    name: "hasReverseMortgageFL",
    label: {
      text: "Do you currently have a reverse mortgage?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.funds,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: FUNDS.hasReverseMortgage,
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: FUNDS.hasReverseMortgage,
        }
      ],
    },
    // 2022.03.24.ADivelbiss - the subquestion is no longer needed.
    // questions: [
    //   {
    //     name: "isUsingReverseMortgageFL",
    //     label: {
    //       text: "Are you using proceeds from a reverse mortgage to fund this annuity?",
    //       justification: 'center'
    //     },
    //     category: QUESTION_CATEGORY.funds,
    //     inputType: QUESTION_INPUT_TYPE.radio,
    //     visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    //     visibilityCondition: {
    //       key: FUNDS.hasReverseMortgage,
    //       operator: '==',
    //       value: QUESTION_RESPONSE_VALUE.yes
    //     },
    //     requirementConditions: true,
    //     response: {
    //       justification: 'center',
    //       labelJustification: 'center',
    //       constraints: [
    //         {
    //           label: "Yes",
    //           value: QUESTION_RESPONSE_VALUE.yes,
    //           key: FUNDS.usingProceedsFromReverseMortgage,
    //         },
    //         {
    //           label: "No",
    //           value: QUESTION_RESPONSE_VALUE.no,
    //           key: FUNDS.usingProceedsFromReverseMortgage,
    //         }
    //       ],
    //     }
    //   }
    // ]
  },
  {
    name: 'additionalInfoFL',
    key: FUNDS.additionalInfo,
    label: {
      text: 'Additional Information:',
      justification: 'center'
    },
    category: QUESTION_CATEGORY.funds,
    inputType: QUESTION_INPUT_TYPE.textArea,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
    requirementConditions: [],
    response: {
      constraints: [
        {
          rows: 3,
          cols: 'auto',
          maxLength: '300'
        }
      ]
    }
  },

  // FL General Questions
  {
    name: "saleArrangementFL",
    label: {
      text: "Have you or any proposed owner entered into, or is any Owner planning to enter into an arrangement with a thrid party to sell this annuity?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.general,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GENERAL.saleArrangement
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GENERAL.saleArrangement
        }
      ]
    }
  },
  {
    name: "trustEstablishmentFL",
    label: {
      text: "Is the purchase of this annuity in any way connected to or based on information provided during the establishment of a trust?",
      colSpan: {
        displayWide: 8,
        displayNarrow: 12
      }
    },
    category: QUESTION_CATEGORY.general,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: GENERAL.trustEstablishment
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: GENERAL.trustEstablishment
        }
      ]
    },
    questions: [
      {
        name: "trustEstablishmentFLExp",
        key: GENERAL.trustEstablishmentFLExp,
        category: QUESTION_CATEGORY.financial,
        label: "If yes, please explain:",
        inputType: QUESTION_INPUT_TYPE.textArea,
        visualOrientation: QUESTION_VISUAL_ORIENTATION.vertical,
        visualSpacing: 1,
        visibilityCondition: {
          key: GENERAL.trustEstablishment,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              rows: 3,
              cols: 'auto',
              maxLength: '300'
            }
          ]
        }
      }
    ]
  },
  // End FL General Questions

  // FL Submit Client Questions
  {
    name: "infoRefuse",
    key: APP_SUBMISSION.infoRefuse,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'I REFUSE to provide this information at this time',
        }
      ]
    }
  },
  {
    name: "infoLimited",
    key: APP_SUBMISSION.infoLimited,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'I have chosen to provide LIMITED information at this time',
        }
      ]
    }
  },
  {
    name: "purchaseIsNotRecommended",
    key: APP_SUBMISSION.purchaseIsNotRecommended,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'My annuity purchase IS NOT BASED on the recommendation of this agent or the insurer',
        }
      ]
    }
  },
  {
    name: "purchaseIsRecommended",
    key: APP_SUBMISSION.purchaseIsRecommended,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'My annuity purchase IS BASED on the recommendation of this agent or the insurer',
        }
      ]
    }
  },
  {
    name: "producerAuthorized",
    key: APP_SUBMISSION.producerAuthorized,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'I authorize my producer to communicate information related to this Annuity Application and Suitability Questionnaire to the Company on my behalf',
        }
      ]
    }
  },
  // End FL Submit Client Questions

  // FL Submit Agent Questions
  {
    name: "proposedAdvantagesFL",
    key: APP_SUBMISSION.proposedAdvantages,
    label: "Advantages of purchasing the proposed annuity:",
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.text,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: []
    }
  },
  {
    name: "proposedDisadvantagesFL",
    key: APP_SUBMISSION.proposedDisadvantages,
    label: "Disadvantages of purchasing the proposed annuity:",
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.text,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: []
    }
  },
  {
    name: "basisOfRecommendationFL",
    key: APP_SUBMISSION.basisOfRecommendation,
    label: "The basis for my recommendation to purchase the proposed annuity or to replace or exchange your existing annuity(ies):",
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.text,
    category: QUESTION_CATEGORY.submission,
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: []
    }
  },
  {
    name: "ownerAnnuitantActiveDutyFL",
    label: {
      text: "Is the Owner or Annuitant an active duty service member of the United States Armed Forces, including reserves?",
      // colSpan: {
      //   displayWide: 8,
      //   displayNarrow: 12
      // }
    },
    category: QUESTION_CATEGORY.submission,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: APP_SUBMISSION.ownerAnnuitantActiveDuty
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: APP_SUBMISSION.ownerAnnuitantActiveDuty
        }
      ]
    },
    questions: [
      {
        name: "ownerAnnuitantActiveDutyFLExp",
        key: APP_SUBMISSION.ownerAnnuitantActiveDutyExp,
        label: {
          icon: 'chevron-right'
        },
        category: QUESTION_CATEGORY.submission,
        inputType: QUESTION_INPUT_TYPE.checkbox,
        placement: 'Question',
        visibilityCondition: {
          key: APP_SUBMISSION.ownerAnnuitantActiveDuty,
          operator: '==',
          value: QUESTION_RESPONSE_VALUE.yes
        },
        requirementConditions: true,
        response: {
          constraints: [
            {
              label: 'I have provided the Military Disclosure form OL5037 to my client',
            }
          ]
        }
      }
    ]
  },
  {
    name: "agentRecommendedFL",
    label: {
      text: "Was the owner's decision to purchase this annuity based on your recommendation?",
      // colSpan: {
      //   displayWide: 8,
      //   displayNarrow: 12
      // }
    },
    category: QUESTION_CATEGORY.submission,
    inputType: QUESTION_INPUT_TYPE.radio,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: true,
    response: {
      justification: 'center',
      labelJustification: 'center',
      constraints: [
        {
          label: "Yes",
          value: QUESTION_RESPONSE_VALUE.yes,
          key: APP_SUBMISSION.agentRecommended
        },
        {
          label: "No",
          value: QUESTION_RESPONSE_VALUE.no,
          key: APP_SUBMISSION.agentRecommended
        }
      ]
    }
  },
  {
    name: "timeKnowingOwnerFL",
    label: {
      text: "How long have you known the proposed Owner?",
      colSpan: {
        displayWide: 7,
        displayNarrow: 12
      }
    },
    key: APP_SUBMISSION.timeKnowingOwner,
    section: APP_SECTION.submission,
    inputType: QUESTION_INPUT_TYPE.select,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.horizontal,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    visibilityCondition: {},
    requirementConditions: true,
    response: {
      constraints: [
        {value: "Less than 1 year", label: "Less than 1 year"},
        {value:  "1-3 years", label: "1-3 years"},
        {value: "4-7 years", label: "4-7 years"},
        {value: "8-10 years", label: "8-10 years"},
        {value: "10 or more years", label: "10 or more years"},
      ]
    }
  },
  // End FL Submit Agent Questions
  
  // Final Submission Questions
  {
    name: "hasTakenRMDforCY",
    label: {
      text: "Have you taken your Required Minimum Distribution (RMD) for this calendar year?",
      // colSpan: {
      //   displayWide: 8,
      //   displayNarrow: 12
      // }
    },
    category: QUESTION_CATEGORY.submission,
    inputType: QUESTION_INPUT_TYPE.radioCheckbox,
    visualOrientation: {
      displayWide: QUESTION_VISUAL_ORIENTATION.vertical,
      displayNarrow: QUESTION_VISUAL_ORIENTATION.vertical
    },
    requirementConditions: [
      {
        AND: [
          {
            section: 'submission',
            key: `${APP_SUBMISSION.hasTakenRMDForCY}_YES`,
            operator: '!=',
            value: 'Yes'
          },
          {
            section: 'submission',
            key: `${APP_SUBMISSION.hasTakenRMDForCY}_NO`,
            operator: '!=',
            value: 'Yes'
          },
        ]
      }
    ],
    response: {
      justification: 'left',
      labelJustification: 'left',
      colCount: {
        displayWide: 1,
        displayNarrow: 1
      },
      constraints: [
        {
          label: "Yes. No action needed",
          key: `${APP_SUBMISSION.hasTakenRMDForCY}_YES`
        },
        {
          label: "No. You will incur penalties and fees if you have not satisfied the RMD for the current calendar year prior to rolling over funds to Nassau.",
          key: `${APP_SUBMISSION.hasTakenRMDForCY}_NO`
        }
      ]
    }
  },
  // END final submission questions
  
  // Question Tests
  {
    name: "testDate",
    key: 'testDate',
    label: "Test Date:",
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.date,
    category: QUESTION_CATEGORY.needs,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          minDate: moment().subtract(MAX_AGE, 'years').toDate(),
          maxDate: moment().subtract(MIN_AGE, 'years').toDate(),
          dateFormat: 'YYYY-MM-DD',
          yearOrderAscending: true
        }
      ]
    }
  },
  {
    name: "testTime",
    key: 'testTime',
    label: "Test Time:",
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.time,
    category: QUESTION_CATEGORY.needs,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [
      {
        key: 'testTime',
        operator: '==',
        value: ''
      }
    ],
    response: {
      constraints: [
        {
          minTime: moment().startOf('day').toDate(),
          maxTime: moment().startOf('day').add(1439, 'minutes').toDate(),
          timeFormat: 'h:mm a',
          incValue: 30,
          incUnit: 'minute'
        }
      ]
    }
  },
  {
    name: "testCurrency",
    key: 'testCurrency',
    label: "Test Currency:",
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.currency,
    category: QUESTION_CATEGORY.needs,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          decimalsEnabled: true,
          decimalPlaces: 2
        }
      ]
    }
  },
  {
    name: "testCheckbox",
    key: 'testCheckbox',
    section: APP_SECTION.needs,
    inputType: QUESTION_INPUT_TYPE.checkbox,
    category: QUESTION_CATEGORY.needs,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {},
    requirementConditions: [],
    response: {
      constraints: [
        {
          label: 'This is a test checkbox.',
        }
      ]
    }
  },
  {
    name: "testRadioCheckbox",
    label: "This is a test radio checkbox",
    category: QUESTION_CATEGORY.needs,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    inputType: QUESTION_INPUT_TYPE.radioCheckbox,
    visualOrientation: QUESTION_VISUAL_ORIENTATION.horizontal,
    response: {
      constraints: [
        {
          label: "Yes",
          key: 'checkbox1'
        },
        {
          label: "No",
          key: 'checkbox2'
        },
        {
          label: "N/A",
          key: 'checkbox3'
        }
      ]
    }
  },
  
  // Question tests and ideas
  {
    name: "ownerIncomeAnnual",
    label: "Annual Income",
    inputType: QUESTION_INPUT_TYPE.select,
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.highest,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {visible: true},
    requirementConditions: [{required: false}],
    responseType: QUESTION_RESPONSE_TYPE.number,
    response: {
      constraints: [
        {value: 0, label: "$0"},
        {value: 1, label: "$1 - $10,000"},
        {value: 2, label: "$10,000 - $20,000"},
        {value: 3, label: "$20,000 - $30,000"},
        {value: 4, label: "$30,000 - $40,000"},
        {value: 5, label: "$40,000 - $50,000"},
        {value: 6, label: "$50,000 - $60,000"},
        {value: 7, label: "$60,000 - $70,000"},
        {value: 8, label: "$70,000 - $80,000"},
        {value: 9, label: "$80,000 - $90,000"},
        {value: 10, label: "$90,000 - $100,000"},
        {value: 11, label: "$100,000 - $110,000"},
        {value: 12, label: "$110,000 - $120,000"},
        {value: 13, label: "$120,000 - $130,000"},
        {value: 14, label: "$130,000 - $140,000"},
        {value: 15, label: "$140,000 - $150,000"},
        {value: 16, label: "$150,000+"}
      ],
    }
  },
  {
    name: "ownerExpensesMonthly",
    label: "Monthly Expenses",
    inputType: QUESTION_INPUT_TYPE.select,
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.veryHigh,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {visible: true},
    requirementConditions: [{required: false}],
    responseType: QUESTION_RESPONSE_TYPE.number,
    response: {
      constraints: [
        {value: 0, label: "$0"},
        {value: 1, label: "$1 - $1,000"},
        {value: 2, label: "$1,000 - $2,000"},
        {value: 3, label: "$2,000 - $3,000"},
        {value: 4, label: "$3,000 - $4,000"},
        {value: 5, label: "$4,000 - $5,000"},
        {value: 6, label: "$5,000 - $6,000"},
        {value: 7, label: "$6,000 - $7,000"},
        {value: 8, label: "$7,000 - $8,000"},
        {value: 9, label: "$8,000 - $9,000"},
        {value: 10, label: "$9,000 - $10,000"},
        {value: 11, label: "$10,000 - $11,000"},
        {value: 12, label: "$11,000 - $12,000"},
        {value: 13, label: "$12,000 - $13,000"},
        {value: 14, label: "$13,000 - $14,000"},
        {value: 15, label: "$14,000 - $15,000"},
        {value: 16, label: "$15,000+"}
      ],
    }
  },
  {
    name: "ownerNetWorth",
    label: "Net Worth",
    inputType: QUESTION_INPUT_TYPE.currency,
    category: QUESTION_CATEGORY.financial,
    subCategory: QUESTION_SUBCATEGORY.unspecified,
    visualPriority: QUESTION_VISUAL_PRIORITY.high,
    visualPresence: QUESTION_VISUAL_PRESENCE.normal,
    visibilityCondition: {
      OR: [
        {
          name: "ownerNetWorth",
          value: "exists"
        },
        {
        
        }
      ]
    },
    requirementConditions: [{required: false}],
    responseType: QUESTION_RESPONSE_TYPE.number,
    response: {
      constraints: [],
    }
  },

];